/**
 * Elastic width workaround for iFrame on iOS 10+ (May 17 2018)
 *
 * The Width/Height of IFrame on iOS, whatever the values you set, will always have width/height
 * equal to width/height of the document, which gets rendered inside that iFrame. Furthermore,
 * the width/height of iFrame is calculated regarding the entire render tree, not its visible parts.
 *
 * This behavior brings tons of bugs and issues. One of those issues is solved by this workaround.
 *
 * Lets take a look to example of an issue, which gets solved by this workaround. Lets say that we
 * have a page with an iFrame inside it:
 *
 * <iframe src="page.html" style="width: 100px"></iframe>
 *
 * page.html contains the following markup.
 *
 * <title>My Page</title>
 * <body style="overflow: hidden; position: relative">
 *   <div style="position: absolute; top: 0: right: -100px; width: 1px; height: 1px;"></div>
 * </body>
 *
 * As you can see, the <div> goes out of the <body> boundaries. What is the width of iFrame in this
 * case on iOS?
 *
 * My first assumption was — 100px, since <div> will be not displayed in render tree, because of
 * position: relative and overflow: hidden; on it's parent — <body>.
 *
 * But, it's not work that way on iOS. Anyway, the <div> will be displayed inside the render tree
 * causing a larger width of iFrame — 200px.
 *
 * However, this problem might be solved, if we create a wrapper for all elements in <body> with the
 * same styles — overflow: hidden, position: relative. In that case, we will get an expected behavior.
 *
 * <title>My Page</title>
 * <body>
 *   <div style="overflow: hidden; position: relative">
 *     <div style="position: absolute; top: 0: right: -100px; width: 1px; height: 1px;"></div>
 *   </div>
 * </body>
 */
import bowser from 'yola-bowser';

const injectIOSInitialContainer = (liveDOM) => {
  if (!bowser.ios) return;

  const { body } = liveDOM;
  const className = 'ios-elastic-width-workaround';
  const styles = 'position: relative; overflow: hidden;';
  body.innerHTML = `<div class="${className}" style="${styles}">${body.innerHTML}</div>`;
};

export default injectIOSInitialContainer;
